import { tv } from "../../../../node_modules/.pnpm/tailwind-variants@3.2.2_tailwind-merge@3.3.0_tailwindcss@4.1.8/node_modules/tailwind-variants/dist/index.js";
const progressVariants = tv({
  base: "relative w-full border border-(--gray-tag-2-alpha) bg-(--gray-tag-1-alpha) overflow-hidden rounded-full",
  variants: {
    size: {
      sm: "h-1.5",
      default: "h-2",
      lg: "h-3"
    }
  },
  defaultVariants: {
    size: "default"
  }
}), progressIndicatorVariants = tv({
  base: "h-full flex-1 transition-all",
  variants: {
    variant: {
      default: "bg-(--primary-1)",
      exception: "bg-(--red-9)",
      success: "bg-(--green-9)"
    }
  },
  defaultVariants: {
    variant: "default"
  }
}), progressShowValueVariants = tv({
  base: "font-medium whitespace-nowrap",
  variants: {
    size: {
      sm: "text-xs",
      default: "text-sm",
      lg: "text-base"
    },
    variant: {
      default: "",
      exception: "text-(--red-9)",
      success: "text-(--green-9)"
    }
  },
  defaultVariants: {
    size: "default",
    variant: "default"
  }
});
export {
  progressIndicatorVariants,
  progressShowValueVariants,
  progressVariants
};
//# sourceMappingURL=index.js.map
